class Page {
    title = 'page';
    showPage = false;
    showClose = true;
    scrollContainer = {};
}

const instance = new Page();
export default instance;
